// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3DGCn","list":"BalanceDue_list__3yLcb","listRow":"BalanceDue_listRow__1fCmG","total":"BalanceDue_total__sXlGi"};